import { render, staticRenderFns } from "./partyGroupDetail.vue?vue&type=template&id=060b2056&scoped=true"
import script from "./partyGroupDetail.vue?vue&type=script&lang=js"
export * from "./partyGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./partyGroupDetail.vue?vue&type=style&index=0&id=060b2056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b2056",
  null
  
)

export default component.exports